import { render } from "./AboutReverse2.vue?vue&type=template&id=9248bf0a&scoped=true"
import script from "./AboutReverse2.vue?vue&type=script&lang=js"
export * from "./AboutReverse2.vue?vue&type=script&lang=js"

import "./AboutReverse2.vue?vue&type=style&index=0&id=9248bf0a&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9248bf0a"]])

export default __exports__